(function(){
  var timer;
  PegasusTemplate.AutoSaveController = Em.Controller.extend({
    needs: ['frameCommManager'],
    isStandalone: function(){
      return window === window.parent;
    }.property(),
    isCurrent: function(){
      return this.get('lastVersion') === Em.get(PegasusTemplate.CommandManager, 'instance.version');
    }.property('lastVersion', 'PegasusTemplate.CommandManager.instance.version'),
    updateLastSaved: function(){
      this.set('lastSaved', PegasusTemplate.Helpers.strftime( new Date(), '%l:%M %P').toUpperCase());
    },
    lastSaved: function(){
      return PegasusTemplate.Helpers.strftime( new Date(), '%l:%M %P').toUpperCase();
    }.property(),
    lastVersion: 0,
    init: function(){
      this._super();
      Em.run.cancel(timer);
      timer = Em.run.later( this, 'saveSnapshot', 60000 * 3);
    },
    clearTimer: function(){
      Em.run.cancel(timer);
    },
    saveSnapshot: function(){
      //try {
        //if ( this.get('lastVersion') !== Em.get(PegasusTemplate.CommandManager, 'instance.version') ) {
          //this.set('lastVersion', Em.get(PegasusTemplate.CommandManager, 'instance.version'));
          //var translation = Em.I18n.t('g.saving');
          //var mask = $('.saving-mask').length ?
            //$('.saving-mask') :
            //$('<div class="saving-mask"><div class="loading-wrapper"><div class="loading show">'+translation+'...</div></div></div>');
          //mask.appendTo('body');

          //this.get('controllers.frameCommManager').requestSaveSnapshot(
            //PegasusTemplate.IOManager.generateOutput(true)
          //);

          //return true;
        //}
      //}catch(e){} finally {
        //Em.run.cancel(timer);
        //timer = Em.run.later( this, 'saveSnapshot', 60000 * 3);
      //}

      return false;
    }
  });
})();
